<template>
  <div class="check-result-display">
    <img :src="icon" :class="currentState == 'checking' ? 'animate': ''">
    <div class="status-text">{{ lbStatus }}</div>
  </div>
</template>

<script>
const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure',
  partialPass: 'partialPass'
}
import warningIcon from '@/assets/warning-x32.png'
import loadingIcon from '@/assets/loading-x32.png'
import trueIcon from '@/assets/true-x32.png'
import falseIcon from '@/assets/false-x32.png'
export default {
  name: 'CheckResultDisplay',
  props: {
    currentState: { type: String, required: true, validator: (value) => { return Object.keys(states).includes(value) } },
    title: { type: String, default: '' }
  },
  data() {
    return {
      lbStatus: '',
      icon: '',
      rowStyle: ''
    }
  },
  watch: {
    currentState: {
      handler(val) {
        switch (val) {
          case states.checking:
            this.lbStatus = `${this.$t('Message.DataValidation')}`
            this.icon = loadingIcon
            break
          case states.success:
            this.icon = trueIcon
            this.lbStatus = `${this.$t('Message.DataValidatedSuccessfully1')} ${this.title} ${this.$t('Message.DataValidatedSuccessfully2')} ${this.title} ${this.$t('Message.DataValidatedSuccessfully3')}`
            break
          case states.warning:
            this.icon = warningIcon
            this.lbStatus = `${this.$t('Message.DataValidatedWithWarning1')} ${this.title} ${this.$t('Message.DataValidatedWithWarning2')}${this.title} ${this.$t('Message.DataValidatedWithWarning3')}`
            break
          case states.failure:
            this.icon = falseIcon
            this.lbStatus = `${this.$t('Message.DataValidatedFailure1')} ${this.title} ${this.$t('Message.DataValidatedFailure2')}`
            break
          case states.partialPass:
            this.icon = warningIcon
            this.lbStatus = `${this.$t('Message.DataValidatedWithPartialPass1')} ${this.title} ${this.$t('Message.DataValidatedSuccessfully2')} ${this.title} ${this.$t('Message.DataValidatedWithPartialPass3')} ${this.title}`
            break
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.check-result-display{
  margin: 5px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #000;
  .status-text {
    margin: 15px 0;
    padding-left: 10px;
    font-size: 14px;
    word-break: break-word;
    white-space: normal;
    text-align: center;
    max-width: 100%;
  }
  .animate{
    animation: loadingAnimation 2s infinite;
    -webkit-animation: loadingAnimation 2s infinite;
    -moz-animation: loadingAnimation 2s infinite;
    -o-animation: loadingAnimation 2s infinite;
  }
}

@keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-moz-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}

@-o-keyframes loadingAnimation{
  0%{
    transform:rotate(0deg)
  }
  100%{
    transform: rotate(360deg);
  }
}
</style>
